<template>
  <div v-if="detail == 'facility'" class="grid grid-cols-12 gap-x-10 mt-8 mb-5">
    <div class="col-span-12">
      <div class="flex items-center justify-between">
        <h5><i class="dot"></i>{{ title }}</h5>
      </div>
      <vs-table class="table1 mt-5" v-model="selectedField" @selected="handleSelected" pagination :data="list">
        <template slot="thead">
          <vs-th> No.</vs-th>
          <vs-th> 시설물명</vs-th>
          <vs-th> 담당 주무관</vs-th>
          <vs-th> 준공일</vs-th>
          <vs-th> 사업금액</vs-th>
          <vs-th> 시설물 위치(주소)</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ data[indextr].id }}</vs-td>
            <vs-td> {{ data[indextr].field_name }}</vs-td>
            <vs-td> {{ data[indextr].manager_name }}</vs-td>
            <vs-td> {{ getDate(data[indextr].be_completed_at) }}</vs-td>
            <vs-td> {{ data[indextr].deposit_amount }}</vs-td>
            <vs-td> {{ data[indextr].address }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- 시설물 세부 정보 -->
    <div v-if="showDetail" class="col-span-12">
      <div class="flex items-center justify-between">
        <h5><i class="dot"></i>시설물 세부 정보</h5>
      </div>
      <div class="mt-5">
        <div class="grid grid-cols-12 gap-x-6 gap-y-4">
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">시설물명</div>
            <vs-input class="w-full flex-1" v-model="selectedField.field_name" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">담당 주무관</div>
            <vs-input class="w-full flex-1" v-model="selectedField.field_name" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">준공일</div>
            <div class="w-full flex-1">
              <date-selector class="w-full" v-model="selectedField.be_completed_at" :readonly="true" />
            </div>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">사업금액</div>
            <vs-input class="w-full flex-1" v-model="selectedField.deposit_amount" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">사업장 주소</div>
            <vs-input class="w-full flex-1" v-model="selectedField.address" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center"></div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">구분</div>
            <vs-input class="w-full flex-1" :value="selectedField && selectedField.facility_category ? selectedField.facility_category.cat1 : ''" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">종류</div>
            <vs-input class="w-full flex-1" :value="selectedField && selectedField.facility_category ? selectedField.facility_category.cat2 : ''" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">세분류</div>
            <vs-input class="w-full flex-1" :value="selectedField && selectedField.facility_category ? selectedField.facility_category.cat3 : ''" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">종별</div>
            <vs-input class="w-full flex-1" :value="selectedField && selectedField.facility_category ? selectedField.facility_category.classification : ''" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">안전 등급</div>
            <vs-input class="w-full flex-1" v-model="selectedField.safety_grade" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">형식</div>
            <vs-input class="w-full flex-1" v-model="selectedField.format" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">규모1</div>
            <vs-input class="w-full flex-1" v-model="selectedField.scale1" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">규모2</div>
            <vs-input class="w-full flex-1" v-model="selectedField.scale2" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">규모3</div>
            <vs-input class="w-full flex-1" v-model="selectedField.scale3" :readonly="true"></vs-input>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="grid grid-cols-12 gap-x-10 mt-8 mb-5">
    <div class="col-span-12">
      <div class="flex items-center justify-between">
        <h5><i class="dot"></i>사업장 현황</h5>
      </div>
      <vs-table class="table2 mt-5" v-model="selectedField" @selected="handleSelected" pagination :data="list">
        <template slot="thead">
          <vs-th> No.</vs-th>
          <vs-th> 사업장명</vs-th>
          <vs-th> 담당 주무관</vs-th>
          <vs-th> 사업기간</vs-th>
          <vs-th> 사업금액</vs-th>
          <vs-th> 사업장 주소</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ data[indextr].id }}</vs-td>
            <vs-td> {{ data[indextr].field_name }}</vs-td>
            <vs-td> {{ data[indextr].manager_name }}</vs-td>
            <vs-td> {{ getDate(data[indextr].work_begin_at) }} ~ {{ getDate(data[indextr].work_end_at) }}</vs-td>
            <vs-td> {{ data[indextr].deposit_amount }}</vs-td>
            <vs-td> {{ data[indextr].address }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- 사업장 세부 정보 -->
    <div v-if="showDetail" class="col-span-12">
      <div class="flex items-center justify-between">
        <h5><i class="dot"></i>사업장 세부 정보</h5>
      </div>
      <div class="mt-5">
        <div class="grid grid-cols-12 gap-x-6 gap-y-4">
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">사업장명</div>
            <vs-input class="w-full flex-1" v-model="selectedField.field_name" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">담당 주무관</div>
            <vs-input class="w-full flex-1" v-model="selectedField.field_name" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">사업기간</div>
            <div class="w-full flex flex-1">
              <date-selector v-model="selectedField.work_begin_at" :readonly="true" />
              <label class="px-2 flex" style="align-items: center">~</label>
              <date-selector v-model="selectedField.work_end_at" :readonly="true" />
            </div>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">사업금액</div>
            <vs-input class="w-full flex-1" v-model="selectedField.deposit_amount" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">사업장 주소</div>
            <vs-input class="w-full flex-1" v-model="selectedField.address" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">사업장 연락처</div>
            <vs-input class="w-full flex-1" v-model="selectedField.phone" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">구분</div>
            <vs-input class="w-full flex-1" :value="selectedField && selectedField.facility_category ? selectedField.facility_category.cat1 : ''" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">종류</div>
            <vs-input class="w-full flex-1" :value="selectedField && selectedField.facility_category ? selectedField.facility_category.cat2 : ''" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">세분류</div>
            <vs-input class="w-full flex-1" :value="selectedField && selectedField.facility_category ? selectedField.facility_category.cat3 : ''" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">현장소장</div>
            <vs-input class="w-full flex-1" v-model="selectedField.director_name" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">안전관리자</div>
            <vs-input class="w-full flex-1" v-model="selectedField.safety_manager_name" :readonly="true"></vs-input>
          </div>
          <div class="col-span-4 flex items-center">
            <div class="label-text mr-4">계약번호</div>
            <vs-input class="w-full flex-1" :readonly="true"></vs-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
export default {
  name: "CompanyFieldList",
  components: { DateSelector },
  props: {
    title: {
      type: String,
      default: () => "사업장 현황",
    },
    list: Array,
    showDetail: Boolean,
    detail: {
      type: String,
      default: () => "workspace",
    },
  },
  data() {
    return {
      selectedField: {},
    };
  },
  methods: {
    getDate(date) {
      if (date) {
        return new Date(date).format("yyyy-MM-dd");
      }
      return "";
    },
    handleSelected(field) {
      this.$emit("select", field);
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
.table1::v-deep,
.table2::v-deep {
  th .vs-table-text {
    justify-content: center;
  }
  td {
    text-align: center;
  }
}
</style>
